import Component from './knowledgeBaseV2.component';
import { Config } from './knowledgeBaseV2.config';

export default { Component, config: Config };
